import Cookies from "universal-cookie";
import ConstantStrings from "../../constants/ConstantStrings";
import moment from "moment/moment";

const cookies = new Cookies();

export const checkAndGetAnonymousUserId = () => {
  var anonymousUserId = cookies.get("anonymousUser");
  if (anonymousUserId) {
    return undefined;
  } else {
    // let uuid = window.crypto.randomUUID();
    // anonymousUserId = uuid.split("-").join("").substring(0, 24);

    // cookies.set("anonymousUser", anonymousUserId, {
    //   path: "/",
    //   maxAge: 24 * 60 * 60,
    // });

    return undefined;
  }
};

export const checkRouteCategoryRoadMap = (router) => {
  switch (router) {
    case "/roadmap-exam":
      return ConstantStrings.IKMC_ID;
    case "/exam-preparation-HK1":
      return ConstantStrings.HK1_ID;
    case "/exam-preparation-HK2":
      return ConstantStrings.HK2_ID;

    default:
      return ConstantStrings.IKMC_ID;
  }
};

export const USER_REGULAR_TYPE = 1;
export const USER_IKMC_TYPE = 2;
export const USER_TEST_PREP_TYPE = 3;
export const SCREEN_PRACTICE = "PRACTICE";
export const SCREEN_IKMC = "IKMC";
export const SCREEN_UPGRADE = "UPGRADE";

// export const checkPremium = (userInfo,isShowSolution = false) => {
//   var result = false;
//   if (
//     userInfo !== null &&
//     userInfo?.premiumFrom &&
//     userInfo?.premiumTo &&
//     new Date(userInfo?.premiumFrom).getTime() <= new Date().getTime() &&
//     new Date(userInfo?.premiumTo).getTime() > new Date().getTime()
//   ) {
//     result = true;
//   } else if (userInfo?.studentType?.type === USER_IKMC_TYPE) {
//     if (isShowSolution) {
//       result = false;
//     }else{
//       result = true;
//     }
//   } else if (userInfo?.premiumFrom === null || userInfo?.premiumTo === null) {
//     result = false;
//   }
//   return result;
// };

export const checkPremium = ({
  userInfo,
  isShowSolution = false,
  screen = "other",
}) => {
  let hasPremiumAccess = false;

  if (userInfo) {
    const { studentType } = userInfo;
    if (checkPremiumActive(userInfo)) {
      if (
        studentType?.type === USER_TEST_PREP_TYPE &&
        ![SCREEN_PRACTICE, SCREEN_UPGRADE, SCREEN_IKMC].includes(screen)
      ) {
        hasPremiumAccess = false;
      } else {
        hasPremiumAccess = true;
      }
    } else if (
      [USER_IKMC_TYPE, USER_TEST_PREP_TYPE].includes(studentType?.type)
    ) {
      hasPremiumAccess = screen === SCREEN_IKMC;
    } else if (studentType?.type === USER_REGULAR_TYPE) {
      hasPremiumAccess = screen === SCREEN_IKMC && isShowSolution ? true : false;
    }
  }

  return hasPremiumAccess;
};

export const checkPremiumActive = (userInfo) => {
  const { premiumInfo, gradeId } = userInfo;
  const now = moment();
  if (!premiumInfo || premiumInfo.length === 0) {
    return false;
  }
  const result = premiumInfo.some((premium) => {
    const startAtValid =
      premium.startAt && moment(premium.startAt).isSameOrBefore(now);
    const endAtValid = premium.endAt && moment(premium.endAt).isAfter(now);
    const isActive = (startAtValid && endAtValid) || endAtValid;
    return premium.gradeId === gradeId && isActive;
  });
  return result;
};

export const isUserAlreadyHasPremiumInPackage = (
  userPremiumInfo,
  packageGradeIds
) => {
  const now = moment();
  if (!userPremiumInfo || !packageGradeIds || userPremiumInfo.length === 0) {
    return false;
  }

  return userPremiumInfo.some((premium) =>
    packageGradeIds.some((gradeId) => {
      const startAtValid =
        premium.startAt && moment(premium.startAt).isSameOrBefore(now);
      const endAtValid = premium.endAt && moment(premium.endAt).isAfter(now);
      const isActive = (startAtValid && endAtValid) || endAtValid;
      return premium.gradeId === gradeId && isActive;
    })
  );
};

export const getPremiumCurrentGrade = (userInfo) => {
  const { premiumInfo, gradeId } = userInfo;
  if (!premiumInfo || premiumInfo.length === 0) {
    return null;
  }

  const premium = premiumInfo.find((item) => item.gradeId === gradeId);
  return premium ? premium.endAt : null;
};

export const checkShowSolutionIkmc = (userInfo) => {
  let hasPremiumAccess = false;
  if (userInfo) {
    const { studentType } = userInfo;
    if (checkPremiumActive(userInfo)) {
      hasPremiumAccess = true;
    } else {
      hasPremiumAccess = studentType?.type === USER_TEST_PREP_TYPE;
    }
  }

  return hasPremiumAccess;
};

